// @ts-check
import { UserCheck } from 'lucide-react';

const HRTrackerPage = () => {
  return (
    <div className="space-y-6">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div>
          <h1 className="text-3xl font-serif">HR Tracker</h1>
          <p className="text-muted-foreground mt-1">Human resource management</p>
        </div>
      </div>

      <div className="bg-card rounded-lg border border-border p-12 text-center">
        <UserCheck size={48} className="mx-auto text-muted-foreground/70 mb-4" />
        <h2 className="text-xl font-medium text-foreground mb-2">HR Tracker</h2>
        <p className="text-muted-foreground">Future feature - Coming soon</p>
      </div>
    </div>
  );
};

export default HRTrackerPage;
